/* eslint-disable import/no-anonymous-default-export */
import API from 'services/API';
import { getIdByRole } from 'services/API/FlightStatus';

export const get = () => API.get('/flight');

/** Vols de la course courante portant le statut indiqué (résolu par son nom, pas par un id fixe). */
export const getByStatusRole = role =>
  getIdByRole(role).then(statusId => {
    if (!statusId) {
      return { data: [] };
    }
    return API.get(`/flight/findByStatus?statusId=${statusId}`);
  });

export const getScheduled = () => getByStatusRole('VALIDATED');

export const getCancelled = () => getByStatusRole('CANCELLED');

export const add = flight => API.post('/flight', flight);

export const edit = (flight, id) => API.patch(`/flight/${id}`, flight);

export const getById = id => API.get(`/flight/${id}`);

export const getByDate = (start, end) => API.get(`/flight/findByDate?startDate=${start}&endDate=${end}`);

export const bulkDelete = flights => API.delete('/flight/byBulk', { data: flights });

export const bulkCancel = flights =>
  getIdByRole('CANCELLED').then(statusId => {
    if (!statusId) {
      throw new Error('Statut « Cancelled » introuvable pour cette course');
    }
    return API.patch('/flight/statusByBulk', { flightStatusId: statusId, ...flights });
  });

export const exportData = () => API.get('/export/csv/full/Flight', { responseType: 'blob' });

export const postValidate = (flights) => API.post('/flight/validate', flights);

export default { get, getById };
